import { number, oneOfType, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSlideshowItem({ backgroundUrl, headingText, paragraphText, buttonText, buttonUrl, itemWidth }) {
    return (<div
        className={'hero-slideshow__item'}
        style={{ width: `${itemWidth}%` }}>
        <img
            src={backgroundUrl}
            alt={headingText} />
        <div
            className={'hero-slideshow__item--inner'}>
            <h2
                className={'hero-slideshow__item--heading'}>{headingText}</h2>
            <p
                className={'hero-slideshow__item--text'}>{paragraphText}</p>
            <Link
                className={'hero-slideshow__item--btn'}
                to={buttonUrl}>{buttonText}</Link>
        </div>
    </div>);
}

HeroSlideshowItem.propTypes = {
    backgroundUrl: string,
    headingText: string,
    paragraphText: string,
    buttonText: string,
    buttonUrl: string,
    itemWidth: oneOfType([number, string]),
};